<ng-container *ngIf="!(accountService.account | async)">
  <ng-container *ngIf="connectWalletTemplate">
    <ng-container *ngTemplateOutlet="connectWalletTemplate; context: { connectButtonRef: this }"></ng-container>
  </ng-container>
  <button type="button" [ngClass]="btnClass" (click)="connect()" *ngIf="!connectWalletTemplate">Connect Wallet</button>
</ng-container>
<ng-container *ngIf="accountService.account | async">
  <ng-container *ngIf="!(chainMatched | async)">
    <ng-container *ngIf="switchNetworkTemplate">
      <ng-container *ngTemplateOutlet="switchNetworkTemplate; context: { connectButtonRef: this }"></ng-container>
    </ng-container>
    <button type="button" [ngClass]="btnClass" (click)="switchNetwork()" *ngIf="!switchNetworkTemplate">{{ switchText }}</button>
  </ng-container>
  <ng-container *ngIf="chainMatched | async">
    <ng-content></ng-content>
  </ng-container>
</ng-container>
